export default "__VITE_ASSET__BNHChwjm__"